import request from '@/utils/request'

export function login(data) {
  console.log('get')
  return request({
    url: '/login',
    method: 'POST',
    params:data
  })
}

// 企业微信登陆
export function wxLogin(data) {
  console.log('wx login POST')
  return request({
    url: '/employee/wxLogin',
    method: 'POST',
    params:data
  })
}

export function getInfo() {
  return request({
    url: '/sys/user/queryCurrentUser',
    method: 'get',
  })
}
export function getSysInfo() {
  return request({
    url: '/sys/sysConfig/getSysInfo',
    method: 'get',
  })
}

export function logout() {
  return request({
    url: '/ajaxLogout',
    method: 'get'
  })
}
